// ChallengePage — entry / overview for the challenge wizard
// iOS HIG: large title + inset-grouped steps list + bottom primary button

import { useNavigate } from 'react-router-dom';
import { Card, PillButton } from '../UIShell';

export function ChallengePage() {
  const nav = useNavigate();
  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-[34px] font-bold leading-[1.1] tracking-tight text-[#1C1C1E]">Start a challenge</h1>
        <p className="mt-1 text-[15px] text-[#8E8E93]">Takes about 60 seconds.</p>
      </div>

      <Card>
        <ol className="space-y-4">
          <li className="flex items-start gap-4">
            <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-[#007AFF] text-[17px] font-semibold text-white">1</span>
            <div>
              <p className="text-[17px] font-semibold text-[#1C1C1E]">Choose your tier</p>
              <p className="mt-0.5 text-[13px] text-[#8E8E93]">Beginner, Mid or Professional — each tier has different rules and profit split.</p>
            </div>
          </li>
          <li className="flex items-start gap-4">
            <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-[#007AFF] text-[17px] font-semibold text-white">2</span>
            <div>
              <p className="text-[17px] font-semibold text-[#1C1C1E]">Choose your account size</p>
              <p className="mt-0.5 text-[13px] text-[#8E8E93]">$50K, $100K or $150K funded accounts.</p>
            </div>
          </li>
          <li className="flex items-start gap-4">
            <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-[#007AFF] text-[17px] font-semibold text-white">3</span>
            <div>
              <p className="text-[17px] font-semibold text-[#1C1C1E]">Choose your trading platform</p>
              <p className="mt-0.5 text-[13px] text-[#8E8E93]">Deepchart, ATAS, Deepdom, Quantower or Bookmap.</p>
            </div>
          </li>
        </ol>
        <div className="mt-6 flex flex-col gap-3">
          <PillButton
            onClick={() => nav('/portal/challenge/tier')}
            trailingIcon={<svg viewBox="0 0 24 24" className="h-5 w-5" fill="none" stroke="currentColor" strokeWidth="2.4"><path d="M5 12h14M13 6l6 6-6 6" strokeLinecap="round" strokeLinejoin="round"/></svg>}
          >
            Start new challenge
          </PillButton>
          <button onClick={() => nav('/portal/platforms')} className="text-center text-[15px] font-normal text-[#007AFF] active:opacity-40">
            Already have a challenge? View your platforms
          </button>
        </div>
      </Card>
    </div>
  );
}
